// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__qDAJp","loaderElements":"loader_loaderElements__i11jW","loader":"loader_loader__Cilih","loadingText":"loader_loadingText__vNbQt"};